import { render, staticRenderFns } from "./BaseSelector.vue?vue&type=template&id=46a3c6a4&scoped=true&"
import script from "./BaseSelector.vue?vue&type=script&lang=js&"
export * from "./BaseSelector.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelector.vue?vue&type=style&index=0&id=46a3c6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a3c6a4",
  null
  
)

export default component.exports